<template>
  <div class="module-title" :class="type">
    <span>{{label}}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    type: {
      type: String,
      default: 'dark'
    }
  }
}
</script>

<style lang="less" scoped>
  .module-title{
    font-size: 1.563vw;
    padding: 3.125vw 0;
    display: flex;
    justify-content: space-between;
  }
  .dark{
    color: #222;
  }
  .light{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/moduleTitle.vue